
export interface SubTpl {
  title: string;
  tplId: string;
  params: [string, string][];
  example: [string, string][];
  content: string;
  type: TplType;
}

export interface SubTplMsg {
  templateId: string;
}

export enum TplType {
  Once = 2,
  Repeated = 3,
}

export enum ParamRule {
  Thing = 'thing',
  Number = 'number',
  Letter = 'letter',
  Symbol = 'symbol',
  CharString = 'character_string',
  Time = 'time',
  Date = 'date',
  Amount = 'amount',
  PhoneNumber = 'phone_number',
  CarNumber = 'car_number',
  Name = 'name',
  Phrase = 'phrase'
}


export function formatTip(name: string): string {
  const ruleRegex = /^([a-z_]+)\d+$/;
  const arr = ruleRegex.exec(name)
  const rule = arr[1]
  switch(rule) {
    case ParamRule.Thing:
      return '20个以内字符'
    case ParamRule.Number:
      return '32位以内数字'
    case ParamRule.Letter:
      return '32位以内字母'
    case ParamRule.Symbol:
      return '5位以内符号'
    case ParamRule.CharString:
      return '32位以内数字、字母或符号'
    case ParamRule.Time:
      return '24小时制时间格式（支持+年月日），支持填时间段（用“~”链接）'
    case ParamRule.Date:
      return '年月日格式（支持+24小时制时间），支持填时间段（用“~”连接）'
    case ParamRule.Amount:
      return '1个币种符号+10位以内纯数字，可带小数，结尾可带“元”'
    case ParamRule.PhoneNumber:
      return '17位以内，数字、符号'
    case ParamRule.CarNumber:
      return '8位以内，第一位与最后一位可为汉字，其余为字母或数字'
    case ParamRule.Name:
      return '10个以内纯汉字或20个以内纯字母或符号'
    case ParamRule.Phrase:
      return '5个以内汉字'
    default:
      return ''
  }
}

export function errMsg(code: string, msg: string, pMap?: {[k: string]: string}): string {
  switch(code) {
    case '40003':
      return '无效openid'
    case '40037':
      return '模板id错误'
    case '43101':
      return '用户拒绝（次数不足或取消订阅）'
    case '47003':
      const p = /data\.([^\.]+)\.value/;
      const arr = p.exec(msg)
      const k = arr[1]
      const err = pMap[k] ? `「${pMap[k]}」格式错误` : msg
      return `参数错误：${err}`
    default:
      return msg
  }
}
